<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>


            <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print1">
              <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
                打印
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
  
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">打印</el-dropdown-item>
                <el-dropdown-item command="1">预览</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>
      <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" border :data="tableData" :max-height="tableHeight"
        :summary-method="getSummaries" show-summary style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column show-overflow-tooltip width="120" label="库房">
          <template slot-scope="scope">
            <span  >{{
              scope.row.warehouseName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="120" v-if="query.viewMode=='3'||query.viewMode=='2'||query.viewMode=='1'" prop="firstCategoryName" label="一级分类名称"></el-table-column>
        <el-table-column show-overflow-tooltip width="120" v-if="query.viewMode=='3'|| query.viewMode=='2'" prop="secondCategoryName" label="二级分类名称"
        ></el-table-column>
        <el-table-column show-overflow-tooltip width="170" v-if="query.viewMode=='3'" prop="supplierProductNo" label="供应商产品编码"
          ></el-table-column>
        <el-table-column show-overflow-tooltip width="140" v-if="query.viewMode=='3'" prop="productName"label="产品名称"
          ></el-table-column>
        <!-- <el-table-column show-overflow-tooltip width="160" prop="startStockNumber" label="期初数量"></el-table-column> -->
        <el-table-column show-overflow-tooltip width="160" prop="startStockAmount" label="期初金额"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip width="160" prop="inStockNumber" label="入项数量合计"></el-table-column> -->

        <el-table-column :key="'purchaseInStock'" label="采购入库" align="center">
          <!-- <el-table-column :key="'purchaseInStockNumber'" width="120" prop="purchaseInStockNumber"
            label="数量"></el-table-column> -->
          <el-table-column :key="'purchaseInStockAmount'" width="120" prop="purchaseInStockAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>
        <el-table-column :key="'deptInStock'" label="科室入库" align="center">
          <!-- <el-table-column :key="'deptInStockNumber'" width="120" prop="deptInStockNumber" label="数量"></el-table-column> -->
          <el-table-column :key="'deptInStockAmount'" width="120" prop="deptInStockAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>
        <el-table-column :key="'applyInStock'" label="请领退库" align="center">
          <!-- <el-table-column :key="'applyInStockNumberOfKeyDepts'" width="110" prop="applyInStockNumberOfKeyDepts"
            label="重点科室数量"></el-table-column> -->
          <el-table-column :key="'applyInStockAmountOfKeyDepts'" width="130" prop="applyInStockAmountOfKeyDepts"
            label="重点科室金额(元)"></el-table-column>
          <!-- <el-table-column :key="'applyInStockNumberOfOtherDepts'" width="110"
            prop="applyInStockNumberOfOtherDepts" label="其他科室数量"></el-table-column> -->
          <el-table-column :key="'applyInStockAmountOfOtherDepts'" width="130"
            prop="applyInStockAmountOfOtherDepts" label="其他科室金额(元)"></el-table-column>
        </el-table-column>
        <el-table-column :key="'celloctInSkock'" label="领用退库" align="center">
          <!-- <el-table-column :key="'celloctInStockNumber'" width="120" prop="celloctInStockNumber"
            label="数量"></el-table-column> -->
          <el-table-column :key="'celloctInStockAmount'" width="120" prop="celloctInStockAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'transferInStock'" label="调拨入库" align="center">
          <!-- <el-table-column width="120" prop="transferInStockNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="transferInStockAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'inventoryProfit'" label="盘盈" align="center">
          <!-- <el-table-column :key="'inventoryProfitNumber'" width="120" prop="inventoryProfitNumber"
            label="数量"></el-table-column> -->
          <el-table-column :key="'inventoryProfitAmount'" width="120" prop="inventoryProfitAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column label="期初入库" align="center">
          <!-- <el-table-column :key="'periodInStockNumber'" width="120" prop="periodInStockNumber"
            label="数量"></el-table-column> -->
          <el-table-column :key="'periodInStockAmount'" width="120" prop="periodInStockAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>
        <!-- <el-table-column :key="'period'" label="异常入库" align="center">
          <el-table-column :key="'dataoffsetsInNumber'" width="120" prop="dataoffsetsInNumber"
            label="数量"></el-table-column>
          <el-table-column :key="'dataoffsetsInAmount'" width="120" prop="dataoffsetsInAmount"
            label="金额(元)"></el-table-column>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip width="160" prop="inStockAmount" label="入项金额合计"></el-table-column>
        <el-table-column :key="'stockProfitAmount'" width="120" label="库存损益（益）" prop="stockProfitAmount"
          align="center"></el-table-column>
        <!-- <el-table-column :key="'outStockNumber'" width="160" prop="outStockNumber" label="出项数量合计"></el-table-column> -->

        <el-table-column :key="'purchaseOutStock'" label="采购退货" align="center">
          <!-- <el-table-column width="120" prop="purchaseOutStockNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="purchaseOutStockAmount" label="金额(元)"></el-table-column>
        </el-table-column>
        <el-table-column :key="'deptOutStock'" label="科室退库" align="center">
          <!-- <el-table-column width="120" prop="deptOutStockNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="deptOutStockAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'transferOutStock'" label="调拨出库" align="center">
          <!-- <el-table-column width="120" prop="transferOutStockNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="transferOutStockAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'applyOutStock'" label="请领出库" align="center">
          <!-- <el-table-column width="110" prop="applyOutStockNumberOfKeyDepts" label="重点科室数量"></el-table-column> -->
          <el-table-column width="130" prop="applyOutStockAmountOfKeyDepts" label="重点科室金额(元)"></el-table-column>
          <!-- <el-table-column width="110" prop="applyOutStockNumberOfOtherDepts" label="其他科室数量"></el-table-column> -->
          <el-table-column width="130" prop="applyOutStockAmountOfOtherDepts" label="其他科室金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'celloctOutStock'" label="领用出库" align="center">
          <!-- <el-table-column width="120" prop="celloctOutStockNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="celloctOutStockAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'losses'" label="报损" align="center">
          <!-- <el-table-column width="120" prop="lossesNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="lossesAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column :key="'inventoryLoss'" label="盘亏" align="center">
          <!-- <el-table-column width="120" prop="inventoryLossNumber" label="数量"></el-table-column> -->
          <el-table-column width="120" prop="inventoryLossAmount" label="金额(元)"></el-table-column>
        </el-table-column>

        <el-table-column label="期初出库" align="center">
          <!-- <el-table-column :key="'periodInStockNumber'" width="120" prop="periodOutStockNumber"
            label="数量"></el-table-column> -->
          <el-table-column :key="'periodInStockAmount'" width="120" prop="periodOutStockAmount"
            label="金额(元)"></el-table-column>
        </el-table-column>
        <!-- <el-table-column label="异常出库" align="center">
          <el-table-column :key="'dataoffsetsOutNumber'" width="120" prop="dataoffsetsOutNumber"
            label="数量"></el-table-column>
          <el-table-column :key="'dataoffsetsOutAmount'" width="120" prop="dataoffsetsOutAmount"
            label="金额(元)"></el-table-column>
        </el-table-column> -->
        <el-table-column :key="'outStockAmount'" width="160" prop="outStockAmount" label="出项金额合计"></el-table-column>

        <el-table-column align="center" prop="stockLossAmount" label="库存损益（损）"></el-table-column>
        <!-- <el-table-column width="160" prop="endStockNumber" label="期末数量"></el-table-column> -->
        <el-table-column width="160" prop="endStockAmount" label="期末金额"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { ExportFinancialStatements, GetFinancialStatements,GetFinancialStatementsPrintData } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import { LevelOptions } from "@/enum";
// import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataSpdMixin, GetDataMixin,], //BaseListMixin
  components: {
    SelectFilter,
  },
  data() {
    return {
      exportAction: ExportFinancialStatements,
      LevelOptions: LevelOptions,
      PrintAction: GetFinancialStatementsPrintData,
      filterOptions: [
        {
          name: "查看方式",
          type: "select",
          code: "viewMode",
          data: [
            {
              id: 0,
              name: "按库房汇总",
            },
            {
              id: 1,
              name: "按一级分类汇总",
            },
            {
              id: 2,
              name: "按二级分类汇总",
            },
            {
              id: 3,
              name: "按明细查看",
            },
          ],
        },
        {
          name: "一级分类",
          type: "input",
          code: "firstCategoryName",
        },
        {
          name: "二级分类",
          type: "input",
          code: "secondCategoryName",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
          filterMethod: this.getProductName
        },
        {
          name: "重点科室",
          type: "select",
          code: "keyDeptIds",
          filterMethod: this.getDepts,
          multiple: true,
          data: [],
        },
        {
          name: "库房级别",
          type: "select",
          code: "warehouseLevel",
          data: LevelOptions,
          defaultvalue: 0,
        }, {
          name: "库房",
          type: "select",
          code: "warehouseIds",
          filterMethod: this.getWarehouses,
          data: [],
          multiple: true,
        },
        {
          name: "时间范围",
          type: "datetimerange",
          code: "date",
          format:'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      loading: false,
      editMode: false,
      stockBalanceLogList: [],
      tableData: [],
      totalData: [],
      productPageTotal: 0,
      patientPageTotal: 0,
      total: 0,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      dataTotalObj: {},
      warehouseLevel: 0,
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        for (const key in this.dataTotalObj) {
          console.log(column.property == key);
          if (column.property == key) {
            if (key.includes("Amount")) {
              sums[index] = this.dataTotalObj[key] + "元";
            } else {
              sums[index] = this.dataTotalObj[key];
            }
          }
        }
      });
      return sums;
    },
    // 编辑
    handleInfo1(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "查看";
      this.editMode = false;
    },
    resetForm() {
      this.form = {
        id: 0,
        warehouseId: "",
        startDate: "",
        endDate: "",
        viewMode:0,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.open = false;
    },
    getData() {

      if( this.query.viewMode.toString()==''){
        this.$my_message('请选择查看方式', "warning");
        this.loading = false
        return
      }
      this.loading = true;
      GetFinancialStatements(this.query)
        .then((res) => {
          if (res.successful) {
            // this.warehouseLevel = res.returnData.dataTotalObj.warehouseLevel;
            this.totalData = res.returnData.data;
            this.total = this.totalData ? this.totalData.length : 0;
            this.tableData = this.getPaginationData(
              this.totalData,
              this.query.pageIndex,
              this.query.pageSize
            );
            this.dataTotalObj = res.returnData.dataTotalObj;
          } else {
            this.$message.error(`${res.errorMessage}`);
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
            this.$refs.multipleTable.doLayout();
          });
        });
    },

    getPaginationData(list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    printList(command) {
      this.query.type = command;

      // GetStockBalancePrintData(this.query)
      //   .then(res => {
      //     var result = res.returnData

      //     var printData = this.printDataConvert(result.printData)
      //     this.sendPrintMessage(JSON.stringify(printData));
      //   })
    },
    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        viewMode:0,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    print1(command) {
      
      this.query.type = command;
      this.PrintAction(this.query)
        .then((res) => {
          var result = res.returnData;
          var printData = this.printDataConvert(result.printData);
          this.sendPrintMessage(JSON.stringify(printData));
        });
    },
  },
  created() { },
  mounted() {
    this.$refs["selectFilter"].query.viewMode = 0;
    this.$refs["selectFilter"].query.viewModeName = '按库房汇总';
    this.getDepts()
    // this.getData()
  },
  // updated() {
  //   this.$nextTick(() => {
  //     this.$refs.multipleTable.doLayout();
  //   });
  // },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}

// /deep/.el-table--border .el-table__cell {
//   border-right: 0px !important;
// }
.warehouseName {
  color: #136af2;
}

.warehouseName:hover {
  cursor: pointer;
}

/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>